import { TextField } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../transl';
import { _IEditProps } from './_IEditProps';

const readonlyInputProps = { readOnly: true, disabled: false };
const readwriteInputProps = { readOnly: false, disabled: false };
const inputLabelProps = { shrink: true };

export const _IdsAsStringEdit = observer(function _IdsAsStringEdit(props: _IEditProps & {children: React.ReactNode}) {
	const {accessors, label, error, isRequired, isReadonly, className, helperText, classes, children, members, ...rest} = props;
	const value = accessors.getter() as string;
	const ids = value.split(/[, ]/).filter(s => s).map(s => +s);
	const setIds = (ids: Array<number>) => accessors.setter(ids.join(','));
	function renderValue(v: any) : string {
		const unique = v.length===1 && members?.find(m => m.id===v[0])?.text || undefined;
		if (unique) return unique;
		if (!v.length) return transl('pleaseSelect');
		return v.length + ' ' + transl('wholesalers');
	}
	return <TextField
		select
		SelectProps={{
			displayEmpty: true,
			multiple: true,
			renderValue,
		}}
		className={className}
		disabled={isReadonly}
		error={error}
		helperText={helperText}
		InputLabelProps={inputLabelProps}
		inputProps={isReadonly ? readonlyInputProps : readwriteInputProps}
		label={label}
		onChange={e => setIds(e.target.value as any)}
		required={isRequired}
		value={ids}
	>
		{children}
	</TextField>;
});
